<template>
  <div>
    <van-popup
      @click-overlay="clickOverlay"
      :close-on-click-overlay="true"
      v-model="giftShow"
      position="bottom"
      :safe-area-inset-bottom="true"
    >
      <div class="title">
        <p>道具打赏</p>
        <img
          @click="showList"
          width="20"
          height="20"
          src="../assets/img/bangdana.png"
          alt=""
        />
      </div>
      <!-- <van-empty description="暂无道具" /> -->
      <ul class="gift-list-box">
        <li
          v-for="(val, ind) in list"
          :key="ind"
          :class="{ active: val.active }"
          @click="checkGift(val, ind)"
        >
          <van-image
            width="60"
            height="50"
            fit="contain"
            :src="val.propImageLowPath || val.propImagePath"
          />
          <p>{{ val.propName }}</p>
          <span>{{ val.propPrice }}元</span>
        </li>
      </ul>
      <div class="gift-num">
        <div>
          <p>数量</p>
          <van-stepper v-model="number" min="1" class="gift-stepper" />
        </div>        
        <div class="sendGift" @click="save">
          赠送
        </div>
      </div>
    </van-popup>
    <van-overlay
      :show="listOpen"
      @click="listOpen = false"
      :lock-scroll="false"
      class="tips-list"
    >
      <ul class="list-gift" @click.stop>
        <li ><img @click="listOpen = false" class="chahao" src="@/assets/img/cuods.png"></li>
        <li class="list-gift-head-img">
          <img src="@/assets/img/jiangfds.png"  />
        </li>
        <li class="list-gift-title">打赏列表</li>
        <li class="list-gift-list">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <p v-for="(val, ind) in personnel" :key="ind">
              <ul class="list-gift-list-item">
                <li>
                  <span>{{ind+1}}</span>
                  <van-image
                    round
                    width="30px"
                    height="30px"
                    fit="cover"
                    :src="val.headimgurl"
                  >
                  </van-image>
                  <p>{{val.nick}}</p>
                </li>
                <li>
                  <p>贡献</p>
                  <span>{{val.price}}元</span>
                </li>
              </ul>
            </p>
          </van-list>
        </li>
      </ul>
    </van-overlay>
  </div>
</template>

<script>
import axiox from "@/utils/server";
export default {
  data() {
    return {
      number: 0,
      giftId: null,
      list: this.giftList,
      listOpen: false,
      personnel: [],
      loading: false,
      finished: false,
      giftShow:false,
      getListData: {
        pageIndex: 1,
        pageSize: 10,
        activityId: this.tvId,
      },
    };
  },
  
  props: {
    giftList: {
      default: () => {
        return [];
      },
      required: true,
    },
    tvId: {
      default: "",
      required: true,
    },
  },
  model: {
    prop: "show",
    event: "popupShow",
  },
  created () {
  },
  methods: {
    clickOverlay() {
      this.$emit("popupShow", false);
    },
    checkGift(val, ind) {
      this.list = this.list.map((value, index) => {
        if (index == ind) {
          value.active = true;
        } else {
          value.active = false;
        }
        return value;
      });
      this.giftId = val;
    },
    save() {
      if (this.giftId) {
        this.$emit("send", {
          giftId: this.giftId,
          number: this.number,
        });
        this.clickOverlay();
      } else {
        this.$toast.fail("请选择礼物");
      }
    },
    onLoad() {
      this.getListData.pageSize += 10;
      this.getList()
    },
    getList(){
      axiox
        .get("/order/list", { params: this.getListData })
        .then(({ data }) => {
          if (data.status == 0) {
            this.personnel = data.data.list;
            this.loading = false;
            if (this.personnel.length == data.data.total) {
              this.finished = true;
            }
          }
        });
    },
    showList(){
      this.getList()
      this.clickOverlay()
      this.giftShow = false
      this.listOpen=true
    }
  },
};
</script>

<style scoped>
.sendGift{
  font-size: 14px;
  background-color: #4594FF;
  width: 35px;
  border-radius: 20px;
  color: white;
  padding: 6px 15px;
  padding-right: 10px;
}
.title {
  height: 40px;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  box-sizing: border-box;
  border-bottom: 1px solid #eee;
}
.title > p {
  font-size: 16px;
  color: #333333;
}
.gift-list-box {
  width: calc(100% - 30px);
  margin: 0 auto;
  height: 230px;
  overflow: hidden;
  overflow-y: auto;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  justify-content: space-between;
  flex-wrap: wrap;
}
.gift-list-box > li {
  width: 80px;
  height: 90px;
  margin: 10px 0;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid transparent;
}
.gift-list-box > li > p {
  font-size: 14px;
  height: 20px;
  line-height: 20px;
  color: #333;
  width: 80%;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.gift-list-box > li > span {
  font-size: 12px;
  height: 20px;
  line-height: 20px;
  color: #787878;
  width: 80%;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.gift-list-box > .active {
  border: 1px solid #72aaff;
  border-radius: 10px;
  background-color: #ecf0ff;
}
.gift-num {
  width: calc(100% - 30px);
  margin: 0 auto;
  height: 40px;
  box-sizing: border-box;
  border-top: 1px solid #eee;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.gift-num > div {
  display: flex;
  align-items: center;
}
.gift-num > div > p {
  font-size: 14px;
  color: #333333;
  margin-right: 10px;
}
.list-gift {
  width: 300px;
  height: 500px;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 99999!important;
}
.list-gift .chahao{
  position: absolute;
  right: 0;
  top: 10px;
  z-index: 99;
}
.list-gift-head-img {
  width: 100%;
  height: 80px;
  position: relative;
  overflow: hidden;
}
.list-gift-head-img > img {
  width: 280px;
  height: 150px;
  object-fit: contain;
}
.list-gift-title {
  background-color: #6799ff;
  height: 40px;
  line-height: 40px;
  color: #fff;
  font-size: 16px;
  text-align: center;
  border-radius: 5px 5px 0px 0px;
}
.list-gift-list {
  height: 380px;
  background-color: #fffcf3;
  border-radius: 0px 0px 5px 5px;
  overflow: hidden;
  overflow-y: auto;
  padding-right: 10px;
}
.list-gift-list-item{
  height: 45px;
  border-bottom: 1px solid #F3F3F3;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.list-gift-list-item>li{
  display: flex;
  align-items: center;
}
.list-gift-list-item>li:nth-child(1)>span{
  width: 20px;
  height: 20px;
  font-size: 12px;
  color: #4594FF;
  text-align: center;
  line-height: 20px;
  background-color: #E3ECFF;
  margin: 0 10px;
  border-radius: 50%;
  overflow: hidden;
}
.list-gift-list-item>li:nth-child(1)>p{
  color: #333333;
  font-size: 16px;
  margin-left: 10px;
}
.list-gift-list-item>li:nth-child(2){
  flex-shrink: 0;
}
.list-gift-list-item>li:nth-child(2)>p{
  color: #8A8A8A;
  font-size: 14px;
  margin-right: 5px;
}
.list-gift-list-item>li:nth-child(2)>span{
  color: #4594FF;
  font-size: 14px;
}
</style>
<style>
.tips-list{
  z-index: 999!important;

}
.list-gift{
  z-index: 9999!important;
}
.gift-stepper > button {
  width: 30px;
  height: 26px;
  border: 1px solid#D1D4D7;
  background-color: #fff;
}
.gift-stepper > button:first-child {
  border-radius: 13px 0 0 13px;
}
.gift-stepper > button:last-child {
  border-radius: 0 13px 13px 0;
}
.gift-stepper > input {
  background-color: #fff;
  margin: 0;
  width: 38px;
  height: 26px;
  border-top: 1px solid #d1d4d7;
  border-bottom: 1px solid #d1d4d7;
}
</style>
